import List from '@utils/list'
import { $t } from '@plugin/i18n'
import { Operation } from '@utils/index'
import http from '@plugin/axios'
import ContractDetail from '@/views/common/components/contract-detail.vue'

const { Search, Table, Tabs, Detail, Jurisdiction } = List

const search = new Search('contract.contract')
  .placeholder('searchPlaceholder')
  .add('contractType')
  .add('startDate').merge('date').label('startDate')

const jurisdiction = new Jurisdiction()
  .lib('add').to('Contract.Contract.Add')
  .lib('delete').del('/srmContract/deleteContractByIds', process.env.VUE_APP_CONTRACT_API)

const tabOptions = [{ name: $t('contract.contract.tabOptions[0]'), status: '0' }, { name: $t('contract.contract.tabOptions[1]'), status: '1' }]
const tabs = new Tabs().api(() => Promise.resolve(tabOptions))

async function audit(this: any, row: any) {
  await this.$confirm(this.$t(`contract.contract.statusMessage[${row.status}]`))
  await http({
    url: '/srmContract/updateContractStatus',
    baseURL: process.env.VUE_APP_CONTRACT_API,
    data: { id: row.id, status: row.status === 1 ? 0 : 1 }
  })
  this.refresh()
}

const table = new Table('contract.contract')
  .add('contractNumber').link()
  .add('contractName')
  .add('contractType')
  .add('signDate')
  .add('startDate')
  .add('endDate')
  .add('jiaOrganization')
  .add('yiOrganization')
  .add('contractDesc').width(160)
  .add('notifyNumber')

const operation = new Operation('contract.contract')
  .add('audit').show(item => item.status === 0).handle(audit)
  .add('cancelAudit').show(item => item.status === 1).handle(audit)

function api(data: any): Promise<any> {
  if (data.condition && data.condition.status === undefined) {
    data.condition.status = 0
  }
  return http({ url: '/srmContract/getContractPage', baseURL: process.env.VUE_APP_CONTRACT_API, data })
}

const detail = new Detail('contract.contract')
  .setSpan(24)
  .add('detail').label('').border(false).component(ContractDetail)

export default new List()
  .api(api)
  .jurisdiction(jurisdiction)
  .tabs(tabs)
  .search(search)
  .table(table)
  .operation(operation)
  .detail(detail)
  .end()
